export default __webpack_public_path__ + "static/media/icon_white_orange@4x.05fc7ace.png";